import { generateRouteList } from "./config/permissions";

export default function PageRouteList() {
  // Generate route list from unified MENU_STRUCTURE
  const RouteList = generateRouteList();
  
  return { RouteList };
}
